import { jsx as _jsx } from "react/jsx-runtime";
import { useDependencies } from 'hooks';
import React from 'react';
const TaxAssistance = /*#__PURE__*/ React.lazy(()=>import(/* webpackPrefetch: true */ 'taxAssistance/App'));
const TaxAssistanceWrapper = ()=>{
    const services = useDependencies();
    return /*#__PURE__*/ _jsx(TaxAssistance, {
        deps: services
    });
};
export const TaxAssistanceRoutes = ()=>[
        {
            path: '/bank-plus/tax-assistance/*',
            component: /*#__PURE__*/ _jsx(TaxAssistanceWrapper, {})
        }
    ];
